import { createAppSlice } from "../../app/createAppSlice"
import type { PayloadAction } from "@reduxjs/toolkit"
import { DrawingId } from "../../entities"
import { TLPageId, type TLStoreSnapshot } from "tldraw"
import { saveToBlobStore } from "../../blobs"

/** Info about a drawing, doesn't include the actual content */
export type DrawingMeta = {
  id: DrawingId
  name: string
  // increment this when the drawing data is updated
  // and persisted to storage
  // in order to notify ui components that the drawing preview has been updated
  version: number
}

type State = {
  pageSettingsDialogOpen: boolean
  editorBlob: {
    data: TLStoreSnapshot
    pageId: TLPageId
  } | null
  editingLayer: boolean
}

const initialState: State = {
  pageSettingsDialogOpen: false,
  editorBlob: null,
  editingLayer: false,
}

const appSlice = createAppSlice({
  name: "app",
  initialState,
  reducers: {
    setEditingLayer(state, action: PayloadAction<boolean>) {
      state.editingLayer = action.payload
    },
    showPageSettingsDialog(state) {
      state.pageSettingsDialogOpen = true
    },
    hidePageSettingsDialog(state) {
      state.pageSettingsDialogOpen = false
    },
  },
  extraReducers: (builder) => {
    builder
  },
})

export async function saveBlob({
  key,
  pageId,
  data,
}: {
  key: string
  pageId: TLPageId
  data: TLStoreSnapshot
}) {
  // update storage
  console.log("Saving to blob store", key, pageId, data)
  await saveToBlobStore(key, { pageId, data })
}

export const {
  showPageSettingsDialog,
  hidePageSettingsDialog,
  setEditingLayer,
} = appSlice.actions

export default appSlice.reducer
